import { i, s, x } from '../../lit-element.js';
import { reset } from '../../styles/reset.style.js';

const style = i`
  :host {
    align-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
    margin-top: 0.75em;
    padding: 0 1em;
    text-align: center;
  }

  :host([hidden]) {
    display: none;
  }

  slot::slotted(*) {
    max-width: 60em;
  }

  slot::slotted(h2) {
    font-size: 2em;
    font-weight: 300;
    line-height: 1.3;
    margin: 0 auto 0.75em;
  }

  slot::slotted(h3) {
    font-size: 1em;
    font-weight: 400;
    line-height: 1.5;
    margin: 0 auto 2em;
  }
`;

class RefiPageHeader extends s {
  static get styles() {
    return [reset, style];
  }

  render() {
    return x` <slot></slot> `;
  }
}

export { RefiPageHeader };
